module.exports = __webpack_public_path__ + "media/images/logo-with-text-7a50d265.svg";